module.exports = __webpack_public_path__ + "static/media/cheeseburger-close.fa7e1fc3.svg";